import { ValidationFailure } from '../types/ValidationFailure';

type ValidationResult<Failure extends ValidationFailure = ValidationFailure> = {
  isValid: boolean;
  failures: Failure[];
};

const validResult: ValidationResult = { isValid: true, failures: [] };

export const reduceValidationResults = <Failure extends ValidationFailure = ValidationFailure>(
  results: ValidationResult<Failure>[]
): ValidationResult<Failure> =>
  results.reduce(
    (prev, current) => ({
      isValid: prev.isValid && current.isValid,
      failures: [...prev.failures, ...current.failures],
    }),
    validResult as ValidationResult<Failure>
  );
